import React from "react";
import PropTypes from "prop-types";
import Button from "../button/Button";
import Title from "../title/Title";
import * as classes from "./CallToAction.module.css";

const CallToAction = ({ title, text = "", action = null }) => {
  const activateAction = (buttonLink) => {
    if (buttonLink !== null) {
      if (buttonLink.includes("http://") || buttonLink.includes("https://")) {
        window.open(buttonLink);
      } else if (!buttonLink.includes("http://") && !buttonLink.includes("https://")) {
        window.location.href = buttonLink;
      }
    }
  }

  return (
    <div className={classes.wrapper}>
      <Title
        title={title}
        content={text}
        primary
        center
        subtitle
        callToAction
      />
      {action.label && (
        <div className={classes.cta}>
          <Button primary onClick={() => {
            activateAction(action.action);
          }}>
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
};

CallToAction.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  action: PropTypes.object
};
export default CallToAction;
